import { render, staticRenderFns } from "./newAddDialog.vue?vue&type=template&id=0226da2c&scoped=true"
import script from "./newAddDialog.vue?vue&type=script&lang=js"
export * from "./newAddDialog.vue?vue&type=script&lang=js"
import style0 from "./newAddDialog.vue?vue&type=style&index=0&id=0226da2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0226da2c",
  null
  
)

export default component.exports